import { render, staticRenderFns } from "./TaxonomyActionForceMassDeleteDialog.vue?vue&type=template&id=73c44374&"
import script from "./TaxonomyActionForceMassDeleteDialog.vue?vue&type=script&lang=ts&"
export * from "./TaxonomyActionForceMassDeleteDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports